import React from 'react';
import styled from 'styled-components';
import times from 'lodash/times';
import { Box } from '../Box/Box';
import { Progress } from './Step';
import { Shimmer } from '../Shimmer/Shimmer';
import { MarginProps } from '../../../theme/styledProps';

const Wrapper = styled(Box)({
  display: 'flex',
  gap: 4,
});

const LoadingStep = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

interface Props extends MarginProps {
  stepCount?: number;
}

export const StepperLoading: React.FC<Props> = ({ stepCount = 5, ...rest }) => {
  return (
    <Wrapper {...rest}>
      {times(stepCount).map(key => (
        <LoadingStep key={key}>
          <Progress variant="incomplete" />

          <Box display="flex" alignItems="center" gridGap="4">
            <Shimmer width="50%" height={10} />
          </Box>
        </LoadingStep>
      ))}
    </Wrapper>
  );
};
